function navigationGroups() {
    const menus = document.querySelectorAll('.gh-primary-navigation-group');
    if (!menus.length) return;

    const currentPath = window.location.pathname.replace(/\/+$/, '/') || '/';

    menus.forEach(function (menu) {
        const activeLink = Array.from(menu.querySelectorAll('a')).find(function (link) {
            return new URL(link.href).pathname.replace(/\/+$/, '/') === currentPath;
        });

        if (activeLink) {
            menu.classList.add('is-active');
            activeLink.classList.add('is-active');
        }
    });
}
